import './firewall.scss'

import { faCircleNotch, faExclamationTriangle, faTimes } from '@fortawesome/free-solid-svg-icons';
import { first } from 'rxjs/operators';
import { defineComponent } from 'vue';

import { User } from '@skinsoft/types'
import { userSelectors } from '@skinsoft/selectors'
import { DEFAULT_PROXY } from '@skinsoft/network';
import { UserAuthenticatedResult } from '@skinsoft/auth';
import { reactiveVueMixin } from '@skinsoft/reactive-vue';

export const Firewall = defineComponent({
    mixins: [reactiveVueMixin],
    props: ['collabWarningMessage', 'noGroupForUserWarningMessage'],
    template: require('./firewall.html'),
    data() {
        return {
            user: null as User | null,
            userSelectors,

            userHasCollaborator: false,
            isUserInGroup: true,
            showCollabWarning: true,
            collabRequestPending: true,
            groupRequestPending: true,

            lastLoadedWorkspaceId: null as string | null,

            warningIcon: faExclamationTriangle,
            closeIcon: faTimes,
            loadingIcon: faCircleNotch,
        }
    },
    computed: {
        authorized(): boolean {
            return !!this.user;
        },
        pending(): boolean {
            return this.collabRequestPending && this.groupRequestPending;
        },
    },
    methods: {
        loadWorkspaceData(workspaceId){
            if (this.authorized && this.lastLoadedWorkspaceId === workspaceId) {
                // Navbar re-emits change_current_workspace for the already-current workspace on every boot.
                return;
            }
            this.lastLoadedWorkspaceId = workspaceId;
            this.reset();
            if (this.user) {
                DEFAULT_PROXY.fetch("/groups/userGroup", {
                    userId: this.user.id,
                    workspace: workspaceId
                }).pipe(first()).toPromise()
                    .then(
                        group => {
                            this.groupRequestPending = false;
                            this.isUserInGroup = !!group;
                        }
                    )
                    .catch(
                        error => {
                            this.groupRequestPending = false;
                            this.isUserInGroup = false;
                        }
                    )

                this.$collaboratorDataStore.getCollaboratorByUserId(this.user.id).pipe(first()).toPromise()
                    .then(
                        collab => {
                            this.userHasCollaborator = !!collab;
                            this.showCollabWarning = !this.userHasCollaborator;
                            this.groupRequestPending = false;
                        }
                    ).catch(
                        error => {
                            this.userHasCollaborator = false;
                            this.showCollabWarning = true;
                            this.groupRequestPending = false;
                        }
                    );
            }
            this.reset();
        },
        reset() {
            this.userHasCollaborator = false;
            this.isUserInGroup = true;
            this.showCollabWarning = false;

            this.collabRequestPending = true;
            this.groupRequestPending = true;
        },
    },
    created() {
        this.subscribeToBus('change_current_workspace', (event) => this.loadWorkspaceData(event.payload));
        this.subscribeTo(this.$authService.user$, (authResult: UserAuthenticatedResult | null) => {
            this.reset();
            this.user = authResult?.user ?? null;
            if (authResult?.user) {
                if(localStorage.getItem('workspace')){
                    this.loadWorkspaceData(localStorage.getItem('workspace'));
                }else{
                    const defaultWorkspace = userSelectors.defaultWorkspace(authResult.user)
                    const defaultWorkspaceId = defaultWorkspace?.workspaceId ?? defaultWorkspace?.id
                    if(defaultWorkspaceId) {
                        this.loadWorkspaceData(defaultWorkspaceId)
                    }
                }
            }
        })
    },
    mounted() {
        this.reset();
    },
})
